<template>
  <div class="block-content">
    <b-row>
      <b-col
        cols="12"
        class="mb-2"
      >
        <b-card
          title="Current Main Highlight"
          class="main-highlight-section"
        >
          <b-card-body>
            <b-card-text v-html="expert.main_highlight" />
          </b-card-body>
          <b-card-footer class="text-right">
            <small>{{ lastUpdateText }}</small>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col cols="6">
        <multiselect
          v-model="selectedProject"
          class="mt-1"
          :options="projectList"
          track-by="projectId"
          label="projectTitle"
          placeholder="Existing Project Highlights"
          :searchable="true"
          :internal-search="true"
          :allow-empty="true"
          @select="projectSelected"
          @remove="projectRemoved"
        >
          <template
            slot="singleLabel"
            slot-scope="{ option }"
          >
            {{ option.projectTitle }}
          </template>
        </multiselect>

        <b-form-checkbox
          v-if="bioHighlight != null"
          :id="`use-linkedin-bio-${expert.id}`"
          v-model="useBioChecked"
          class="mt-1"
          switch
        >
          Use LinkedIn Bio
        </b-form-checkbox>
      </b-col>
      <b-col cols="6">
        <vue-editor-clean-text :content.sync="mainHighlight" />
        <b-button
          class="mt-2"
          size="sm"
          @click="setMainHighlight"
        >
          <b-spinner
            v-if="updating"
            small
            type="grow"
          />
          Update Main Highlight
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name: "SummarySelectButton",
    components: { Multiselect },
    props: {
        expert: { type: Object, required: true },
        bioHighlight: { type: String, default: "" },
    },
    data() {
        return {
            useBioChecked: false,
            selectedProject: null,
            mainHighlight: "",
            tmpHighlight: null,
            updating: false,
        };
    },
    computed: {
        lastUpdateText() {
            if (!this.expert.expert_bio) {
                return null;
            }

            if (this.expert.expert_bio.main_summary === null && this.bioHighlight != null) {
                return "LinkedIn Bio";
            } else if (this.expert.expert_bio.last_summary_update_user !== null) {
                let lastUpdateText = "";
                if (this.expert.expert_bio.main_summary_updated_at !== null) {
                    const lastUpdate = this.$moment.utc(this.expert.expert_bio.main_summary_updated_at).format("D MMMM YYYY HH:MMa");
                    lastUpdateText = `, ${lastUpdate} UTC`;
                }

                return `Last updated: ${this.expert.expert_bio.last_summary_update_user.full_name}${lastUpdateText}` ?? "";
            }

            return null;
        },
        projectList() {
            return this.expert.assignments?.filter(assignment => assignment.expert_summary !== null)
                .map(function(elm) {
                    return {
                        projectTitle: elm.project.project_title,
                        id: elm.id,
                        projectId: elm.project.id,
                        summary: elm.expert_summary,
                        is_main_summary: elm.is_main_summary,
                    };
                }) ?? [];
        },
    },
    watch: {
        useBioChecked: function(checkState) {
            if (checkState) {
                this.mainHighlight = this.bioHighlight;
            } else {
                this.mainHighlight = this.expert.main_highlight;
            }

            this.selectedProject = null;
        },
    },
    created() {
        this.updateHighlight(this.expert.main_highlight);
    },
    methods: {
        updateHighlight(value) {
            this.mainHighlight = value;
            this.tmpHighlight = this.mainHighlight;
        },
        projectRemoved(removedOption, id) {
            this.updateHighlight(this.expert.main_highlight);
        },
        projectSelected(selectedOption, id) {
            this.selectedProject = selectedOption;
            this.updateHighlight(selectedOption.summary);
            this.useBioChecked = false;
        },
        setMainHighlight() {
            try {
                if (this.mainHighlight !== "") {
                    this.updating = true;
                    const mainSummary = this.mainHighlight;
                    const stripedSummary = this.stripSearchTag(mainSummary);

                    axios.post(`/admin/experts/api/summaries/${this.expert.id}/updateMain`,
                        {
                            main_highlight: stripedSummary,
                        }).then(async res => {
                        await this.$store.dispatch("expert/updateExpertData", { expertId: this.expert.id });

                        await this.$bvModal.msgBoxOk(`Main highlight updated`);

                        await this.resetSelection();
                    }).finally(() => {
                        this.updating = false;
                    });
                } else {
                    this.updating = false;
                    One.helpers("jq-notify", {
                        type: "warning",
                        icon: "fa fa-exclamation me-1",
                        message: "Please enter main highlight",
                    });
                }
            } catch (err) {
                console.log(err);
            }
        },
        resetSelection() {
            this.useBioChecked = false;
            this.selectedProject = null;
        },
        stripSearchTag(summaryText) {
            const div = document.createElement("div");
            div.innerHTML = summaryText;

            const searchedDiv = $(div).find(".searchHighlight");

            if (searchedDiv.length) {
                const searchText = searchedDiv.text();
                searchedDiv.replaceWith(searchText);
                return $(div).text();
            }
            return summaryText;
        },
    },
};
</script>

<style scoped>
</style>
